
import { useParams } from 'react-router-dom';

import { DisenioPaginas } from '../../layout';
import { useProductoXID } from '../../../hooks';
import { CargandoMedio, FormCreateUpdateProducto } from '../../components';




export const ActualizarProducto = () => {


    const { id } = useParams();
    const { productoXIDQuery } = useProductoXID(`${id}`);
    const producto = productoXIDQuery?.data
    
    
    const initialState = (producto) ? {
        nombre: producto.nombre || '',
        precioSin: producto.precioSin || '',
        unidadMedida: producto.unidadMedida._id || '',
        iva: producto.iva || '',
        categoria: producto.categoria || '',
        proveedor: producto.proveedor || [],
        detalles: producto.detalles || '',
    } : {};



    return (

        <DisenioPaginas titulo="Actualizar Producto" url={1} add={false} subtitulo="Información de producto">
            {(productoXIDQuery.isLoading)
            ?   <CargandoMedio titulo="Cargando Producto..." />
            :   <FormCreateUpdateProducto initialState={initialState} />
            }
        </DisenioPaginas>
    
    )    
}
